[
  {
    "id": "event-list",
    "name": "Event List",
    "description": "Include your channel's most recent events into your stream.",
    "settings_url": "https://streamlabs.com/dashboard/eventlist",
    "featured": true,
    "preview": "https://cdn.streamlabs.com/static/imgs/landing/widget-thumbnails/event-list.mp4",
    "icon": "lucide:list"
  },
  {
    "id": "follower-goal",
    "name": "Follower Goal",
    "description": "Set a follower goal for your viewers to help you reach.",
    "settings_url": "https://streamlabs.com/dashboard/followergoal",
    "icon": "lucide:goal"
  },
  {
    "id": "viewer-count",
    "name": "Viewer Count",
    "description": "Show the number of viewers watching.",
    "settings_url": "https://streamlabs.com/dashboard/viewercount",
    "icon": "lucide:eye"
  },
  {
    "id": "end-credits",
    "name": "End Credits",
    "description": "Set up a rolling credit to show all the supporters during the session.",
    "settings_url": "https://streamlabs.com/dashboard/credits",
    "icon": "lucide:align-center"
  },
  {
    "id": "game-widget",
    "name": "Game Widget",
    "description": "Allow your chat to play a game.",
    "settings_url": "https://streamlabs.com/dashboard/widgets/game-widget",
    "icon": "lucide:gamepad-2"
  },
  {
    "id": "poll",
    "name": "Poll",
    "description": "Start a poll for your viewers to vote on.",
    "settings_url": "https://streamlabs.com/dashboard/poll",
    "icon": "lucide:vote"
  },
  {
    "id": "alert-box",
    "name": "Alert Box",
    "description": "Reward your loyal viewers by thanking them with attractive, on-stream notification popups.",
    "settings_url": "https://streamlabs.com/dashboard/alertbox",
    "featured": true,
    "preview": "https://cdn.streamlabs.com/static/imgs/landing/widget-thumbnails/alert-box.mp4",
    "icon": "lucide:bell"
  },
  {
    "id": "media-share",
    "name": "Media Share",
    "description": "Allow your viewers to donate to share media on your stream.",
    "settings_url": "https://streamlabs.com/dashboard/mediashare",
    "icon": "lucide:file-video",
    "widget_url_pattern": "https://streamlabs.com/widgets/media/v1/{token}"
  },
  {
    "id": "tip-goal",
    "name": "Tip Goal",
    "description": "Set a donation goal for your viewers to help you reach.",
    "settings_url": "https://streamlabs.com/dashboard/donationgoal",
    "icon": "lucide:badge-dollar-sign"
  },
  {
    "id": "the-jar",
    "name": "The Jar",
    "description": "A jar that catches bits, tips, and more.",
    "settings_url": "https://streamlabs.com/dashboard/jar",
    "icon": "lucide:cup-soda"
  },
  {
    "id": "chat-box",
    "name": "Chat Box",
    "description": "Include your channel's chat into your stream, and make it look pretty while you're at it.",
    "settings_url": "https://streamlabs.com/dashboard/chatbox",
    "featured": true,
    "preview": "https://cdn.streamlabs.com/static/imgs/landing/widget-thumbnails/chat-box.mp4",
    "icon": "lucide:messages-square"
  },
  {
    "id": "tip-ticker",
    "name": "Tip Ticker",
    "description": "Show off your most recent tips to your viewers.",
    "settings_url": "https://streamlabs.com/dashboard/donationticker",
    "icon": "lucide:form-input"
  },
  {
    "id": "stream-boss",
    "name": "Stream Boss",
    "description": "Give your viewers the opportunity to become a boss in your channel by interacting with the stream.",
    "settings_url": "https://streamlabs.com/dashboard/streamboss",
    "icon": "lucide:sword"
  },
  {
    "id": "spin-wheel",
    "name": "Spin Wheel",
    "description": "Spin the wheel, win fabulous prizes!",
    "settings_url": "https://streamlabs.com/dashboard/wheel",
    "icon": "lucide:dices"
  },
  {
    "id": "sponsor-banner",
    "name": "Sponsor Banner",
    "description": "Edit (add, remove, update) rotating sponsor logos on streamer channel.",
    "settings_url": "https://streamlabs.com/dashboard/sponsorbanner",
    "icon": "lucide:heart"
  },
  {
    "id": "sub-goal",
    "name": "Sub Goal",
    "description": "Set a subscriber goal for your viewers to help you reach.",
    "settings_url": "https://streamlabs.com/dashboard/subgoal",
    "icon": "lucide:badge-check"
  },
  {
    "id": "youtube-member-goal",
    "name": "Youtube Member Goal",
    "description": "Set a member goal for your viewers to help you reach.",
    "settings_url": "https://streamlabs.com/dashboard/subgoal?platform=youtube",
    "icon": "lucide:badge-check"
  },
  {
    "id": "emote-wall",
    "name": "Emote Wall",
    "description": "Display and animate emotes that are seen in chat, improving viewer interaction via positive feedback.",
    "settings_url": "https://streamlabs.com/dashboard/widgets/emote-wall",
    "icon": "lucide:laugh",
    "widget_url_pattern": "https://streamlabs.com/widgets/emote-wall?token={token}&profile={profileId}"
  },
  {
    "id": "chat-highlight",
    "name": "Chat Highlight",
    "description": "Pin and highlight a chat message on your stream.",
    "settings_url": "https://streamlabs.com/dashboard/widgets/chat-highlight",
    "icon": "lucide:message-square"
  },
  {
    "id": "bit-goal",
    "name": "Bit Goal",
    "description": "Set a bit goal for your viewers to help you reach.",
    "settings_url": "https://streamlabs.com/dashboard/bitgoal",
    "icon": "lucide:gem"
  },
  {
    "id": "follower-goal",
    "name": "Follower Goal",
    "description": "Set a follower goal for your viewers to help you reach.",
    "settings_url": "https://streamlabs.com/dashboard/followergoal",
    "icon": "lucide:users"
  },
  {
    "id": "you-tube-subscriber-goal",
    "name": "YouTube Subscriber Goal",
    "description": "Set a subscriber goal for your viewers to help you reach.",
    "settings_url": "https://streamlabs.com/dashboard/followergoal?platform=youtube",
    "icon": "lucide:youtube"
  },
  {
    "id": "supporter-goal",
    "name": "Supporter Goal",
    "description": "Set a supporter goal for your viewers to help you reach.",
    "settings_url": "https://streamlabs.com/dashboard/supportergoal",
    "icon": "lucide:facebook"
  },
  {
    "id": "stars-goal",
    "name": "Stars Goal",
    "description": "Set a stars goal for your viewers to help you reach.",
    "settings_url": "https://streamlabs.com/dashboard/starsgoal",
    "icon": "lucide:facebook"
  },
  {
    "id": "streamlabs-charity-donation-goal",
    "name": "Streamlabs Charity Donation Goal",
    "description": "Set a donation goal for your viewers to help you reach.",
    "settings_url": "https://streamlabs.com/dashboard/streamlabs-charity-donation-goal",
    "icon": "lucide:heart-handshake"
  },
  {
    "id": "super-chat-goal",
    "name": "Super Chat Goal",
    "description": "Set a super chat goal for your viewers to help you reach.",
    "settings_url": "https://streamlabs.com/dashboard/super-chat-goal",
    "icon": "lucide:megaphone"
  },
  {
    "id": "twitch-charity-donation-goal",
    "name": "Twitch Charity Donation Goal",
    "description": "Set a donation goal for your viewers to help you reach.",
    "settings_url": "https://streamlabs.com/dashboard/twitch-charity-donation-goal",
    "icon": "lucide:twitch"
  },
  {
    "id": "game-pulse",
    "name": "Game Pulse",
    "description": "Realtime alerts reacting to your in-game events",
    "settings_url": "https://streamlabs.com/dashboard/game-pulse/global",
    "icon": "lucide:gamepad-2",
    "featured": true,
    "preview": "https://cdn.streamlabs.com/marketplace/widget_themes/70160565/369cb2e/media/2b13809d-41a9-4951-b451-ed923c496129.mp4"
  }
]